<template>
	<div class="chargeStandardDispose ">
		<div class="itemTitleBox disStart">
			<span class="title">社区充电收费标准</span>
		</div>
		<div class="BtnBox disBetween">
			<div class="searchBox disBetween">
				<div class="myinputBox">
					<el-input clearable v-model="searchObj.search" placeholder="请输入社区名称"></el-input>
					<!-- <el-select clearable v-model="searchObj.search" filterable remote reserve-keyword
						placeholder="请输入社区关键词" :remote-method="remoteMethod" @change="changeSelect">
						<el-option v-for="item in restaurants" :key="item.communityName" :label="item.communityName"
							:value="item.communityName">
						</el-option>
					</el-select> -->
				</div>
				<div class="myinputBox">
					<el-select clearable v-model="searchObj.equipmentRunStatus" slot="prepend" placeholder="请选择运营状态">
						<el-option v-for="(item,inx) in operateStatusList" :key="inx" :label="item.text"
							:value="item.value"></el-option>
					</el-select>
				</div>
				<el-button type="success" @click="toSearch">查询</el-button>
			</div>

		</div>
		<div class="listBox">
			<div style="height: 100%;width: 100%;" v-loading="loading">
				<div class="content myTable">
					<el-table :data="tableData" stripe style="width: 100%">
						<el-table-column type="index" label="序号" width="60">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityName" label="社区名称">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityTypeName" label="社区类型">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="areaCode" label="地区" width="150">
							<template slot-scope="scope">
								{{scope.row.provinceName}}{{scope.row.cityName}}{{scope.row.areaName}}
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityAddress" label="具体地址" width="150">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentNumber" label="设备数量" width="80">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="equipmentServiceProvider" label="运营商">
						</el-table-column>

						<el-table-column prop="operate" label="操作" width="60">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="itemClick(scope.row)">配置</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination  mypagination">
					<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
						:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
						layout="total, prev, pager, next,jumper" ref="pagination"
						@current-change="handleCurrentChange($event,1)">
					</el-pagination>
				</div>
			</div>

		</div>
		<el-dialog :title="dialogTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogVisible1" width="90%">
			<div class="dialogBox">
				<div class="tabBox disBetween">
					<el-radio-group v-model="tabPosition">
						<el-radio-button v-for="(item,inx) in tabList" :key="inx"
							:label="inx">{{item.minPower}}~{{item.maxPower}}W</el-radio-button>
					</el-radio-group>
					<span class="powermanage" @click="powermanage">功率管理</span>
				</div>
				<div class="disStart" v-for="(item,inx) in itemObj.diaList" :key="inx">
					<div class="nameBox">配置{{inx+1}}</div>
					<div class="numItem disStart">
						<div class="lableBox">充电金额：</div>
						<div class="inputBox">
							<el-input v-model="item.rechargeMoney" type="Number" placeholder=""></el-input>
						</div>
						<div class="unitBox">元</div>
					</div>
					<div class="numItem disStart">
						<div class="lableBox">充电时长：</div>
						<div class="inputBox">
							<el-input v-model="item.rechargeTime" type="Number" placeholder=""></el-input>
						</div>
						<div class="unitBox">分钟</div>
					</div>

					<!-- <div class="btnBox disStart">
						<span class="delIcon" @click="btnClick1(item,inx,1)"></span>
						<span class="addIcon" v-if="inx==itemObj.diaList.length-1"
							@click="btnClick1(item,inx,2)"></span>
					</div> -->
				</div>
			</div>
			<div slot="footer" class="dialog-footer diabtnBox disAround">
				<el-button @click="dialogVisible1 = false">取 消</el-button>
				<el-button type="primary" @click="saveBtn1">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="功率管理" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="dialogVisible2"
			width="70%">
			<div class="dialogBox">
				<div class="disStart" v-for="(item,inx) in MytabList" :key="inx">
					<div class="numItem disStart">
						<div class="inputBox">
							<el-input @input="numberChange(item.minPower,1000,inx,1)" disabled v-model="item.minPower"
								type="Number" placeholder=""></el-input>
						</div>
						<div class="unitBox">~</div>
					</div>
					<div class="numItem disStart">
						<div class="inputBox">
							<el-input @input="numberChange(item.maxPower,1000,inx,2)" v-model="item.maxPower"
								type="Number" placeholder="" @change="changeEnd($event,inx)"></el-input>
						</div>
						<div class="unitBox">W</div>
					</div>
					<div class="btnBox disStart">
						<span class="delIcon" v-if="inx!=0  && inx==MytabList.length-1"
							@click="btnClick2(item,inx,1)"></span>
						<span class="addIcon" v-if="inx==MytabList.length-1 && MytabList.length<10"
							@click="btnClick2(item,inx,2)"></span>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer diabtnBox disAround">
				<!-- <el-button @click="dialogVisible1 = false">取 消</el-button> -->
				<el-button type="primary" @click="saveBtn2">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	var token = localStorage.getItem('token')
	export default {
		name: "chargeStandardDispose",
		components: {},
		props: {
			disposeList: {
				type: Array,
				default: []
			},
		},
		data() {
			return {
				str: "设备",
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				searchObj: {
					search: "",
					pageNo: 1, //当前页
					pageSize: 10, //当
					provinceCode: "", //省级编号
					cityCode: "", //市级编号
					areaCode: "" //区级编号
				},
				operateStatusList: [{
						text: "未投用",
						value: 1
					},
					{
						text: "运营中",
						value: 2
					},
					{
						text: "已拆除",
						value: 3
					},
				],
				tableData: [{
					communityEquipmentNo: "我是社区1"
				}],
				NOfalse: false,
				dialogTitle: "充电金额配置",
				dialogVisible1: false,
				dialogVisible2: false,
				loading: false,
				restaurants: [],
				itemObj: {
					diaList: [],
					itemInfo: {}
				},
				tabList: [],
				MytabList: [],
				tabPosition: 0,
			}
		},
		watch: {
			tabPosition(n) {
				console.log(n)
				if (this.tabList[n].communityBaseSetList && this.tabList[n].communityBaseSetList.length > 0) {
					this.$set(this.itemObj, "diaList", this.tabList[n].communityBaseSetList)
				} else {
					this.$set(this.itemObj, "diaList", [{
						minPower: "",
						maxPower: ""
					}])
				}
			},
		},
		mounted() {
			this.getData()
		},
		methods: {
			remoteMethod(query) {
				let that = this
				if (query !== '') {
					let searchObj = {
						search: query,
						pageNo: 1, //当前页
						pageSize: 1000, //当
						provinceCode: "", //省级编号
						cityCode: "", //市级编号
						areaCode: "" //区级编号
					}
					that.$api.listCommunityInfo(searchObj).then((res) => {
						if (res.returnCode == 200) {
							that.$set(that, "restaurants", res.obj.list)
							setTimeout(() => {
								that.options = that.restaurants.filter(item => {
									return item.communityName.toLowerCase()
										.indexOf(query.toLowerCase()) > -1;
								});
							}, 200);

						}
					})

				} else {
					this.options = [];
				}
			},
			getData(obj) {
				this.loading = true
				this.$api.listCommunityInfo2(this.searchObj).then((res) => {
					if (res.returnCode == 200) {
						this.loading = false
						this.$set(this, "tableData", res.obj.list || [])
						this.$set(this.PageInfo, "total", res.obj.total || 0)
					} else {
						this.loading = false
						this.$message({
							message: res.returnMessage || "请求异常",
							type: 'error'
						});
					}
				})
			},
			changeSelect(n) {

			},
			changeEnd(e, inx) {
				if (inx <= 4) {
					if (this.MytabList[inx + 1]) {
						this.$set(this.MytabList[inx + 1], "minPower", e)
					}

				}
			},
			numberChange(val, maxNum, n, type) {
				//转换数字类型
				let num = Number(val)
				if (num < 0) {
					if (type == 1) {
						this.$set(this.MytabList[n], "minPower", 0)
					} else {
						this.$set(this.MytabList[n], "maxPower", 0)
					}
				}
				if (num > 2000) {
					if (type == 1) {
						this.$set(this.MytabList[n], "minPower", 2000)
					} else {
						this.$set(this.MytabList[n], "maxPower", 2000)
					}
				}
			},
			powermanage() {
				if (this.tabList.length > 0) {
					this.MytabList = this.tabList
				} else {
					this.MytabList = [{
						minPower: 0,
						maxPower: ""
					}]
				}
				this.dialogVisible2 = true
			},
			handleSelect(item) {

				this.$set(this.creatObj, "equipmentServiceProvider", item.value)
			},
			itemClick(item) {
				let that = this
				this.tabPosition = 0
				this.$api.listRechargeBasicSetByCommunityId({
					communityId: item.communityId
				}).then((res) => {
					if (res.returnCode == 200) {

						this.$set(this.itemObj, "communityId", item.communityId)
						if (res.obj && res.obj.length > 0) {
							for (let k of res.obj) {
								for (let j of k.communityBaseSetList) {
									this.$set(j, "rechargeTime", j.rechargeTime * 60)
								}
							}
							this.$set(this, "tabList", res.obj)
							this.$set(this.itemObj, "diaList", res.obj[0].communityBaseSetList)
						} else {
							this.$set(this, "tabList", JSON.parse(JSON.stringify(this.disposeList)))
							this.$set(this.itemObj, "diaList", JSON.parse(JSON.stringify(this.disposeList))[0]
								.communityBaseSetList)
						}
					}
				})
				this.dialogTitle = "充电金额配置(" + item.communityName + ")"
				this.dialogVisible1 = true

			},
			saveBtn2() {
				for (let k of this.MytabList) {
					if (k.maxPower) {
						if (Number(k.maxPower) > Number(k.minPower)) {

						} else {
							this.$message({
								type: "warning",
								message: '请输入正确功率范围！'
							});
							return false
						}
					} else {
						this.$message({
							type: "warning",
							message: '请输入正确功率范围！'
						});
						return false
					}
				}
				this.$nextTick(() => {
					this.$set(this, "tabList", this.MytabList)
					this.$message({
						type: "success",
						message: '配置成功!'
					});
					this.tabPosition = 0
					this.dialogVisible2 = false
				})
			},
			saveBtn1() {
				let newArr=this.tabList
				for (let j of newArr) {
					if (j.communityBaseSetList && j.communityBaseSetList.length > 0) {
						for (let k of j.communityBaseSetList) {
							if (k.rechargeTime === 0 || k.rechargeMoney === 0) {
								this.$message({
									type: 'warning',
									message: '充电时长和充电金额不能为0!'
								});
								return false
							}
							if (k.rechargeTime % 15 != 0) {
								this.$message({
									type: 'warning',
									message: '充电时长请输入15的倍数值!'
								});
								return false
							}
							if (!(k.rechargeTime) || !(k.rechargeMoney)) {
								this.$message({
									type: 'warning',
									message: '充电时长和充电金额不能为空!'
								});
								return false
							}
							k.rechargeTime = parseFloat((k.rechargeTime / 60).toFixed(2))
						}
					} else {
						this.$message({
							type: 'warning',
							message: '充电时长和充电金额不能为空!'
						});
						return false
					}

				}
				let obj = {
					communityId: this.itemObj.communityId,
					rechargePowerSetList: newArr
				}
				this.$api.updateRechargeBasicSetByCommunityId(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$message({
							type: "success",
							message: '配置成功!'
						});
						this.dialogVisible1 = false
					}
				})
			},
			btnClick2(item, inx, n) {
				if (n == 1) {

					if (this.MytabList.length == 1) {
						this.$message({
							type: 'warning',
							message: '最少保留一个功率区间!'
						});
						return false
					}
					let that = this
					this.$confirm('是否确认删除该功率区间?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.MytabList.splice(inx, 1)
						that.$message({
							type: 'success',
							message: '删除成功!'
						});


					}).catch(() => {

					});
				} else if (n == 2) {
					if (this.MytabList.length == 0) {
						this.MytabList.push({
							minPower: 0,
							maxPower: '',
							communityBaseSetList: [{
								rechargeMoney: "",
								rechargeTime: ""
							}]
						})
					} else {
						for (let k of this.MytabList) {
							if (k.maxPower) {
								if (Number(k.maxPower) > Number(k.minPower)) {

								} else {
									this.$message({
										type: "warning",
										message: '请输入正确功率范围！'
									});
									return false
								}
							} else {
								this.$message({
									type: "warning",
									message: '请输入正确功率范围！'
								});
								return false
							}
						}
						this.$nextTick(() => {
							this.$set(this.MytabList, [this.MytabList.length], {
								minPower: this.MytabList[this.MytabList.length - 1].maxPower,
								maxPower: "",
								communityBaseSetList: [{
									rechargeMoney: "",
									rechargeTime: ""
								}]
							})
						})
					}

				}
			},
			btnClick1(item, inx, n) {
				if (n == 1) {
					if (this.itemObj.diaList.length == 1) {
						this.$message({
							type: 'warning',
							message: '最少保存一个标准配置!'
						});
						return false
					}
					let that = this
					this.$confirm('是否确认删除该配置项?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.itemObj.diaList.splice(inx, 1)
						that.$message({
							type: 'success',
							message: '删除成功!'
						});


					}).catch(() => {

					});
				} else {

					this.itemObj.diaList.push({
						rechargeMoney: "",
						rechargeTime: ""
					})
				}
			},
			// 选择分页
			handleCurrentChange(val) {
				this.$set(this.PageInfo, "pagenum", val)
				this.$set(this.searchObj, "pageNo", val)
				this.getData({})
			},
			// 搜索
			toSearch() {
				this.$set(this.PageInfo, "pagenum", 1)
				this.$set(this.searchObj, "pageNo", 1)
				this.getData({})
			},

		}
	}
</script>

<style lang="scss" scoped>
	@import "./chargeStandardDispose.scss"
</style>